<ng-form [formGroup]="form">
<div class="row w-100">
  <div class="col-3">
    <app-checkbox formControlName="checkbox" label="Label"></app-checkbox>
  </div>
  <div class="col-3">
    <app-currency-input [formControl]="form.get('currency')" inputLabel="Currency" [decimals]="2"></app-currency-input>
  </div>
  <div class="col-3">
    <app-date-picker inputLabel="Date picker" warningMessage="Rush" formControlName="deliveryDate"></app-date-picker>
  </div>
  <div class="col-3">
    <app-date-range
      rangeClass="w-100"
      [isRequired]="true"
      formControlName="dateRange"
      [showRanges]="true"
      showLabel="true"
      label="{{ 'module.pages.reports.card-ranges.range-load-request' | translate }}"
      buttonLocation="inside"
    ></app-date-range>
  </div>
  <div class="col-3">
    <app-input formControlName="textInput" inputLabel="Text input" inputClass="w-100" [showLabel]="true" [isRequired]="true"></app-input>
  </div>
  <div class="col-3">
    <app-input
      formControlName="numberInput"
      inputLabel="Number input"
      inputClass="w-100"
      [maxLength]="9"
      [showLabel]="true"
      [numeric]="true"
      [isRequired]="true"
    ></app-input>
  </div>
  <div class="col-3">
    <app-input-form
      [formControl]="form?.get('textInput')"
      showLabel="true"
      inputClass="w-100"
      maxLength="50"
      inputLabel="Text input deprecated"
    ></app-input-form>
  </div>
  <div class="col-3">
    <app-input-chips inputLabel="Chips input (deprecated)" formControlName="chips"></app-input-chips>
  </div>
  <div class="col-3">
    <app-chips label="Input Chips" formControlName="chips" [type]="'number'"></app-chips>
  </div>
  <div class="col-3">
    <app-input-search-dropdown
      [formControl]="form.get('httpSearchDropdown')"
      ngDefaultControl
      [itemsList]="merchantSearch"
      (onSearch)="getMerchants($event)"
      [itemLabelFn]="getMerchantLabel.bind(this)"
      [isLoading]="isLoading$"
      inputLabel="Http backend search"
    ></app-input-search-dropdown>
  </div>
  <div class="col-3">
    <app-percent-input
      inputClass="w-100"
      inputLabel="Percent"
      inputHint="hint"
      formControlName="percent"
      [isRequired]="true"
    ></app-percent-input>
  </div>
  <div class="col-3">
    <app-radio-group-form
      label="Radio Group"
      testId="card_designer"
      formControlName="radioGroup"
      isRequired="true"
      hintIconExist="true"
      inputHint="Hint"
      [buttonValues]="[
        {code: true, name: 'common.label.yes' | translate},
        {code: false, name: 'common.label.no' | translate}
      ]"
    ></app-radio-group-form>
  </div>
  <div class="col-3">
    <app-multiselect-search-dropdown
      formControlName="httpSearchDropdownMultiple"
      [itemListProvider]="userListProvider"
      [isRequired]="true"
      [disableOptionCentering]="true"
      [useCustomToggler]="false"
      label="Multiple http backed dropdown"
    ></app-multiselect-search-dropdown>
  </div>
  <div class="col-3">
    <app-select-search-dropdown
      formControlName="dropdown"
      label="Dropdown"
      [itemsList]="[
        {label: 'Test', extras: ['other'], value: 'test'},
        {label: 'Other', extras: ['test'], value: 'other'}
      ]"
      [isRequired]="true"
    ></app-select-search-dropdown>
  </div>
  <div class="col-3">
    <app-select-search-dropdown
      formControlName="dropdownMultiple"
      label="Dropdown Multiple"
      [isMultiple]="true"
      [itemsList]="[
        {label: 'Test', extras: ['other'], value: 'test'},
        {label: 'Other', extras: ['test'], value: 'other'}
      ]"
      [isRequired]="true"
    ></app-select-search-dropdown>
  </div>
  <div class="col-6">
  </div>
  <div class="col-6">
    <app-file-uploader
      class="w-100"
      type="finance"
      [requestId]="123"
      [initialFiles]="[]"
      [isDisabled]="false"
      uploaderLabel="File upload"
    ></app-file-uploader>
  </div>
</div>
<div class="row w-100">
  <div class="col-6">
    <app-rich-text
      class="w-100"
      inputClass="w-100"
      inputLabel="Rich Text"
      [showLabel]="true"
      formControlName="richText"
      [extras]="['link', 'image']"
      [minHeight]="250"
    ></app-rich-text>
  </div>
  <div class="col-6">
    <app-textarea-form
      class="w-100"
      inputClass="w-100"
      inputLabel="Text"
      [showLabel]="true"
      formControlName="text"
    ></app-textarea-form>
  </div>
</div>
<div>
  <pre>{{ this.form.value | json }}</pre>
</div>
</ng-form>
